import { AxiosResponse } from 'axios'

import { GetProductsConfig, SortType } from 'appTypes/shared'
import apiClient from 'utils/apiClient'

export const productsApi = {
  async getProducts(config: GetProductsConfig, sortConfig?: SortType, itemsPerPage = 20): Promise<AxiosResponse<any>> {
    const { searchTerm, locationId, category, page, itemType } = config

    const type = itemType === 'complementary' ? 'complementary=true' : `complementary=false&productType=${itemType}`

    let base = `/api/products/items?items=${itemsPerPage}&page=${page}&${type}&`

    if (searchTerm !== '') {
      base = `${base}query=${searchTerm}&`
    }

    if (locationId) {
      base = `${base}locationId=${locationId}&`
    }

    if (category !== '') {
      const {
        data: { categories },
      } = await apiClient.get(`/api/products/categories?name=${name}`, {})
      if (categories?.length) {
        base = `${base}category=${categories[0].id}&`
      }
    }

    if (sortConfig) {
      base = `${base}order[field]=${sortConfig.name}&order[direction]=${sortConfig.type}`
    }

    base.replace(/&=$/, '')

    return await apiClient.get(base)
  },

  async getProduct(id: number): Promise<AxiosResponse<any>> {
    return await apiClient.get(`/api/products/items/${id}`)
  },

  async getFeaturedBundles(category: string): Promise<AxiosResponse<any>> {
    return await apiClient.get(`/api/products/items?items=3&product_type=bundle&category=${category}`)
  },
}
